import { Navigate, useParams } from "react-router-dom";
import { PartnerContractsList } from "src/entities/partnerContracts/ui/PartnerContractsList";
import { routes } from "src/shared/constants/routes.constants";

export function PartnerContractsPage() {
  const { partner_id } = useParams();

  if (!partner_id) {
    return <Navigate to={routes.partners} />;
  }

  return <PartnerContractsList partner_id={partner_id} />;
}
